/** Formatos de fecha y número compartidos por todas las pantallas. */

const FECHA_HORA = new Intl.DateTimeFormat('es-VE', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

const HORA = new Intl.DateTimeFormat('es-VE', {
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
});

const FECHA = new Intl.DateTimeFormat('es-VE', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

export function formatearFechaHora(fecha: Date | null | undefined): string {
  return fecha ? FECHA_HORA.format(fecha) : '—';
}

export function formatearHora(fecha: Date | null | undefined): string {
  return fecha ? HORA.format(fecha) : '—';
}

export function formatearFecha(fecha: Date | null | undefined): string {
  return fecha ? FECHA.format(fecha) : '—';
}

/**
 * Antigüedad en lenguaje natural: «hace 2 min», «hace 3 h».
 * Para lecturas de sensores importa más lo reciente que la hora exacta.
 */
export function formatearAntiguedad(fecha: Date | null | undefined, ahora = new Date()): string {
  if (!fecha) return '—';

  const segundos = Math.max(0, Math.floor((ahora.getTime() - fecha.getTime()) / 1000));

  if (segundos < 60) return `hace ${segundos} s`;
  if (segundos < 3600) return `hace ${Math.floor(segundos / 60)} min`;
  if (segundos < 86400) return `hace ${Math.floor(segundos / 3600)} h`;
  return `hace ${Math.floor(segundos / 86400)} d`;
}
